import React from 'react';
import NonSelectedSipCard from '../CauseCardV2/NonSelectedSipCard';
import SipBenefitsCards from '../SipBenefitsCards';
import HowItWorksV2 from '../HowItWorksV2';
import BigImpacts from '../BigImpacts';

const NotSubcribedCausePage = ({cause}) => {
    return (
        <>
            <NonSelectedSipCard campaign_cause={cause} />
            <SipBenefitsCards />
            <HowItWorksV2 />
            <BigImpacts campaign_cause={cause} />
        </>
    )
}

export default NotSubcribedCausePage;
